// utils/tableHeight.js —— 列表页表格高度统一计算（2026-09-23 筛选栏 filter-bar 改造配套）
// 方案：纯实测、零估算——表格 max-height = 视口高 - 筛选卡底缘实测位置 - 底部预留(分页区+边距)。
// 不再依赖 store.windheight（时机/数值不可靠）与任何固定开销常数；
// 筛选卡换行数变化、窗口缩放均由全局 resize 监听自动重算。
export function calcTableHeight(vm, windheight, extra = 0) {
  const bar = vm.$refs.filterBar;
  if (bar && bar.$el) {
    return measure(bar.$el);
  }
  return Math.max(300, window.innerHeight - 310);
}

function measure(barEl) {
  // 筛选卡底缘(getBoundingClientRect 不含 margin-bottom 8px) 到视口底的距离,
  // 再扣 100px 底部预留(分页区约 70px + 页面底边距约 30px)
  const top = barEl.getBoundingClientRect().bottom;
  return Math.max(300, window.innerHeight - top - 150); // 150 = 分页区70 + ve-table表头补偿约50 + 安全余量30
}

// 全局 resize：宽度变化会改变筛选卡换行数, 对当前渲染中的页面重算表格高度
if (typeof window !== 'undefined') {
  window.addEventListener('resize', () => {
    document.querySelectorAll('.filter-bar').forEach(el => {
      // 从元素向上找到最近的组件实例(普通 div 容器无 __vue__,需向上冒泡到页面根),再找持有 tableHight 的页面 vm
      let node = el;
      let comp = null;
      while (node && !comp) {
        comp = node.__vue__;
        if (!comp) node = node.parentElement;
      }
      while (comp && comp.tableHight === undefined) {
        comp = comp.$parent;
      }
      if (comp && comp.$refs.filterBar && comp.$refs.filterBar.$el === el) {
        const h = measure(el);
        if (h !== comp.tableHight) {
          comp.tableHight = h;
        }
      }
    });
  });
}
